import axios from 'axios';
import { API_BASE } from './apiBase';

const BASE_URL = API_BASE;

// Les utilisateurs proposés pour une assignation proviennent exclusivement de
// l'entreprise de la personne connectée.
export const getConseillers = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/users/conseillers`);
    if (!response.data.success) throw new Error(response.data.message || 'Erreur lors du chargement des utilisateurs');
    return { success: true, data: response.data.data };
  } catch (error) {
    console.error('Erreur lors du chargement des utilisateurs assignables:', error);
    // Une liste vide est sûre : aucune donnée d'une autre entreprise ne doit
    // être proposée si la session est expirée ou si le serveur échoue.
    return { success: false, error: error.message, data: [] };
  }
};

export const formatConseillerOptions = (conseillers) => [
  { value: '', label: 'Non assigné' },
  ...conseillers.map((conseiller) => ({ value: conseiller.nomComplet, label: conseiller.nomComplet }))
];

export const getConseillerNames = (conseillers) => conseillers.map((conseiller) => conseiller.nomComplet);
